module.exports = __webpack_public_path__ + "static/media/0_Pain Free.92c83755.svg";